<i18n>
{
    "en_US": {
        "no-title": "_(No title)_"
    },
    "fr_FR": {
        "no-title": "_(Aucun titre)_"
    }
}
</i18n>

<template>
    <div class="markdown-full-preview" :class="{ active: isMarkdownPreviewVisible }">
        <button type="button" class="btn btn-link menu-shrink" v-on:click="showMenuMobile">
            <i class="fa fa-bars"></i>
        </button>
        <button class="btn btn-primary" v-on:click="toggleMarkdownPreview">&times;</button>
        <h1 v-html="markdown(selectedNote.title)"></h1>
        <div v-html="markdown(selectedNote.content)"></div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";
    import Renderer from "plugins/marked";
    

    export default {
        name: "Full",
        computed: {
            ...mapState("note", ["selectedNote"]),
            ...mapState("application", ["isMarkdownPreviewVisible"])
        },
        watch: {
            isMarkdownPreviewVisible: function(newValue) {
                if (newValue === false) {
                    var root = $(this.$el);
                    // Stopping all youtube video (if any)
                    root.find(".youtube-player-iframe").each(function() {
                        this.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"stopVideo\",\"args\":\"\"}", "*");
                    });
                    // Stopping all vimeo video (if any)
                    root.find(".vimeo-player-iframe").each(function() {
                        this.contentWindow.postMessage("{\"method\":\"unload\"}", "*");
                    });
                    // Stopping all dailymotion video (if any)
                    root.find(".dailymotion-player-iframe").each(function() {
                        this.contentWindow.postMessage("{\"command\":\"pause\",\"parameters\":[]}", "*");
                    });
                    // Stopping all facebook video (if any)
                    root.find(".facebook-player-container").each(function() {
                        // Ugly way but I couldn't find a better way...
                        var tmp = $(this).find(".facebook-player-iframe").detach();
                        tmp.appendTo($(this));
                    });
                }
            }
        },
        methods: {
            markdown: function(content) {
                if (content === "_(no title)_") {
                    return marked(this.$t("no-title"), { sanitize: true });
                }

                return marked(content, {
                    renderer: Renderer(),
                    sanitize: false,
                    highlight: function(code) {
                        return hljs.highlightAuto(code).value;
                    }
                });
            },
            ...mapMutations("application", ["showMenuMobile", "toggleMarkdownPreview"])
        }
    }
</script>

<style scoped>
    .markdown-full-preview.active {
        -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
        filter: alpha(opacity=100);
        opacity: 1;
        pointer-events: auto;
    }
    .markdown-full-preview {
        position: absolute;
        display: block;
        pointer-events: none;
        min-height: calc(100%) !important;
        height: calc(100%) !important;
        width: 100%;
        left: 0;
        top: 0;
        z-index: 6;
        padding: 0px 30px;
        overflow: auto;
        background-color: #FDFDFD;
        -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
        filter: alpha(opacity=0);
        opacity: 0;
        -webkit-transition: all 0.5s ease-in-out;
        -moz-transition: all 0.5s ease-in-out;
        -ms-transition: all 0.5s ease-in-out;
        -o-transition: all 0.5s ease-in-out;
        transition: all 0.5s ease-in-out;
    }
    .markdown-full-preview {
        -webkit-transition: all 0.5s ease-in-out;
        -moz-transition: all 0.5s ease-in-out;
        -ms-transition: all 0.5s ease-in-out;
        -o-transition: all 0.5s ease-in-out;
        transition: all 0.5s ease-in-out;
    }
    .markdown-full-preview > div {
        padding-top: 5px;
        margin-top: 0;
        padding-left: 10px;
    }
    .btn-primary {
        position: absolute;
        right: 10px;
        top: 10px;
    }
    .markdown-full-preview > h1 {
        margin-top: 8px;
    }
    .menu-shrink {
        position: absolute;
        left: 10px;
        top: 12px;
        display: none;
    }

    @media screen and (max-width: 985px) {
        .menu-shrink {
            display: inline-block !important;
        }
        .markdown-full-preview > h1 {
            padding-left: 30px;
        }
    }
</style>